import { THOUSANDS_REGEX } from '../../constants';

const NUMBER_REGEX = /[^0-9.]/g;
const MULTIPLE_DECIMAL_REGEX = /(?<=\d*\.\d*)\./g;

class DecimalFormatter {
  constructor(nonnegative = false) {
    this.preFormat = true;
    this.nonnegative = nonnegative;
  }

  static tryParse(format) {
    const m = /^decimal(-nonnegative)?$/.exec(format);

    return m ? new DecimalFormatter(!!m[1]) : null;
  }

  /**
   * Shared by apply() and parse(): a leading minus sign, the digits and the first decimal point, nothing else.
   * Unfinished input ('-', '12.') is kept so it can still be typed. Numbers are read without exponent notation
   * (1e21); strings are read by their characters only, never through Number(), so a string like '1e3' reads as '13'.
   */
  static clean(value) {
    const text =
      typeof value === 'number' ? value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 20 }) : value.toString();
    const body = text.replace(NUMBER_REGEX, '').replace(MULTIPLE_DECIMAL_REGEX, '');

    return text.trimStart().startsWith('-') ? `-${body}` : body;
  }

  /** clean(), minus the sign when the format is "decimal-nonnegative". */
  cleanValue(value) {
    const cleaned = DecimalFormatter.clean(value);

    return this.nonnegative ? cleaned.replace('-', '') : cleaned;
  }

  apply(value) {
    if (value === undefined || value === null || value === '') return '';

    const cleaned = this.cleanValue(value);
    const sign = cleaned.startsWith('-') ? '-' : '';

    const parts = cleaned.slice(sign.length).split('.');
    // Insert a comma every 3 digits, and show at most 2 decimals (display only; parse() saves them all).
    parts[0] = parts[0].replace(THOUSANDS_REGEX, ',');
    if (parts.length > 1) parts[1] = parts[1].slice(0, 2);

    return sign + parts.join('.');
  }

  parse(value) {
    if (value === undefined || value === null || value === '') return value;

    return this.cleanValue(value);
  }
}

export default DecimalFormatter;
